const ApplicationName = 'Self-Service Migration';

export {
    ApplicationName
};
